
import { supabase } from "@/integrations/supabase/client";

/**
 * Checks if a user has sufficient credits for a swap offer
 */
export const verifyCreditBalance = async (userId: string, creditAmount: number): Promise<boolean> => {
  console.log(`Verifying credit balance for user ${userId}, required amount: ${creditAmount}`);
  
  if (creditAmount <= 0) {
    console.log("Credit amount is zero or negative, no validation needed");
    return true;
  }
  
  const { data: profileData, error: profileError } = await supabase
    .from("profiles")
    .select("credit_balance")
    .eq("id", userId)
    .single();
    
  if (profileError) {
    console.error("Error fetching user profile:", profileError);
    return false;
  }
  
  const hasEnoughCredits = profileData.credit_balance >= creditAmount;
  
  if (!hasEnoughCredits) {
    console.log(`Insufficient credits: ${profileData.credit_balance} available, needed: ${creditAmount}`);
    return false;
  }
  
  console.log(`Credit verification passed: ${profileData.credit_balance} available, needed: ${creditAmount}`);
  return true;
};
